import { Params, ParamMap } from '@angular/router';
import { Statuses } from 'src/shared/api';

export const FLASH_AUDIT_STATUSES_KEY = 'fs';

export const toFlashAuditStatusesParams = (args: {
	statuses?: string[];
}): Params => ({
	[FLASH_AUDIT_STATUSES_KEY]: args.statuses ? args.statuses : undefined,
});

export const toFlashAuditStatusesListArgs = (
	paramMap: ParamMap
): { statuses?: Statuses[] } =>
	paramMap.has(FLASH_AUDIT_STATUSES_KEY)
		? {
				statuses: paramMap.getAll(
					FLASH_AUDIT_STATUSES_KEY
				) as Statuses[],
		  }
		: undefined;
